module.exports = __webpack_public_path__ + "static/media/agriculture.aa66d4f3.jpg";